import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const ServiceNowAiAccesses = {
  role: Access({
    label: "Role",
    description:
      "Grant ServiceNow roles to an agent's own ServiceNow machine user; only an agentic session can request it",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      instance: {
        type: "static",
        label: "ServiceNow instance",
        optional: true,
      },
      instanceId: {
        type: "generated",
        label: "ServiceNow instance (resolved)",
      },
      role: {
        type: "static",
        label: "Role",
        description: "Name of a ServiceNow role",
        multivalued: true,
      },
      /** Names the agent's ServiceNow user: one per gateway session. */
      agentKey: {
        type: "generated",
        label: "Agent key",
      },
    },
    render: { locator: "instance", policy: "role" } as const,
  }),
};

export type ServiceNowAiAccesses = typeof ServiceNowAiAccesses;
